import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Базовый компонент, отвечающий за рендер ячеек в табличном движке.
 */
@Component({
    selector: 'app-base-cell',
    template: '{{ getRawValue() }} ',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseCellComponent {
    @Input() column!: { id: string | number; name: string; alias: string; type: string; transformParam?: any };
    @Input() row!: any;

    get alias() {
        return !this.column.alias ? this.column.name : this.column.alias;
    }

    getRawValue() {
        if (this.row[this.alias] === undefined || this.row[this.alias] === null) {
            return '';
        }
        if (typeof this.row[this.alias] === 'object' && this.row[this.alias].length) {
            const result = [];
            this.row[this.alias].forEach((value) => {
                if (value) {
                    result.push(value);
                }
            });
            return result.join(', ');
        }

        return (this.row[this.alias] + '').replace(/{br}/g, ', ');
    }
}
